import "./editar_cadastro.6a33cc6e.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/main.js

var $cpXHg = parcelRequire("cpXHg");

var $gGcib = parcelRequire("gGcib");
document.addEventListener('DOMContentLoaded', ()=>{
    // --- Inicialização do Swiper ---
    try {
        const swiper = new Swiper('.swiper-container', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            }
        });
    } catch (e) {
        console.warn("Swiper n\xe3o p\xf4de ser inicializado. Verifique se a biblioteca est\xe1 carregada e o container existe.", e);
    }
    // --- Elementos do Formulário ---
    const cadastroForm = document.getElementById('cadastro-form');
    const nomeInput = document.getElementById('nome');
    const telefoneInput = document.getElementById('telefone');
    const telefoneInvalidoDiv = document.getElementById('telefone-invalido');
    const cpfInput = document.getElementById('cpf');
    const cpfInvalidoDiv = document.getElementById('cpf-invalido');
    const empresaInput = document.getElementById('empresa');
    const cnpjInput = document.getElementById('cnpj');
    const cnpjInvalidoDiv = document.getElementById('cnpj-invalido');
    const emailInput = document.getElementById('email');
    const emailInvalidoDiv = document.getElementById('email-invalido');
    const termosCheckbox = document.getElementById('termos-lgpd');
    const termosInvalidoDiv = document.getElementById('termos-invalido');
    const gravarCadastroButton = document.getElementById('gravar-cadastro');
    const mensagemCadastroDiv = document.getElementById('mensagem-cadastro');
    const comoSoubeSelect = document.getElementById('como-soube');
    const comoSoubeInvalidoDiv = document.getElementById('como-soube-invalido');
    const comoSoubeOutroContainer = document.getElementById('como-soube-outro-container');
    const comoSoubeOutroInput = document.getElementById('como-soube-outro');
    const comoSoubeOutroInvalidoDiv = document.getElementById('como-soube-outro-invalido');
    //const tipoParticipanteSelect = document.getElementById('tipo-participante'); // INCORRETO
    const tipoParticipanteRadios = document.querySelectorAll('input[name="tipo-participante"]');
    const tipoParticipanteInvalidoDiv = document.getElementById('tipo-participante-invalido');
    const representanteRadios = document.querySelectorAll('input[name="representante"]');
    // --- Elementos da Modal de Sucesso ---
    const successModalOverlay = document.getElementById('success-modal-overlay');
    const successModalBox = document.getElementById('success-modal-box');
    const successModalOkBtn = document.getElementById('success-modal-ok-btn');
    // --- Fim Elementos Modal ---
    // --- Listeners de Formatação e Validação ---
    // Formatação e validação de Telefone
    telefoneInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarTelefoneInput)(e.target.value);
        if (telefoneInvalidoDiv) telefoneInvalidoDiv.style.display = 'none';
    });
    telefoneInput?.addEventListener('blur', (e)=>{
        const tel = (0, $gGcib.limparNumeros)(e.target.value);
        if (telefoneInvalidoDiv) {
            if (tel && (tel.length < 10 || tel.length > 11)) {
                telefoneInvalidoDiv.textContent = "Celular inv\xe1lido (10 ou 11 d\xedgitos).";
                telefoneInvalidoDiv.style.display = 'block';
            } else telefoneInvalidoDiv.style.display = 'none';
        }
    });
    // Formatação e validação de CPF
    cpfInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarCPFInput)(e.target.value);
        if (cpfInvalidoDiv) cpfInvalidoDiv.style.display = 'none';
    });
    cpfInput?.addEventListener('blur', (e)=>{
        const cpf = (0, $gGcib.limparNumeros)(e.target.value);
        if (cpfInvalidoDiv) {
            if (cpf && !(0, $gGcib.validarCPF)(cpf)) {
                cpfInvalidoDiv.textContent = "CPF inv\xe1lido.";
                cpfInvalidoDiv.style.display = 'block';
            } else cpfInvalidoDiv.style.display = 'none';
        }
    });
    // Formatação e validação de CNPJ
    cnpjInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarCNPJInput)(e.target.value);
        if (cnpjInvalidoDiv) cnpjInvalidoDiv.style.display = 'none';
    });
    cnpjInput?.addEventListener('blur', (e)=>{
        const cnpj = (0, $gGcib.limparNumeros)(e.target.value);
        if (cnpjInvalidoDiv) {
            if (cnpj && !(0, $gGcib.validarCNPJ)(cnpj)) {
                cnpjInvalidoDiv.textContent = "CNPJ inv\xe1lido.";
                cnpjInvalidoDiv.style.display = 'block';
            } else cnpjInvalidoDiv.style.display = 'none';
        }
    });
    // Limpar erro de Email ao digitar
    emailInput?.addEventListener('input', ()=>{
        if (emailInvalidoDiv) emailInvalidoDiv.style.display = 'none';
    });
    // Limpar erro dos Termos ao marcar
    termosCheckbox?.addEventListener('change', ()=>{
        if (termosCheckbox?.checked && termosInvalidoDiv) termosInvalidoDiv.style.display = 'none';
    });
    // Mostrar/ocultar campo "Outro" de "Como soube"
    comoSoubeSelect?.addEventListener('change', ()=>{
        const showOutro = comoSoubeSelect.value === 'Outro';
        if (comoSoubeOutroContainer) comoSoubeOutroContainer.style.display = showOutro ? 'block' : 'none';
        if (comoSoubeOutroInput) {
            comoSoubeOutroInput.required = showOutro;
            if (!showOutro) {
                comoSoubeOutroInput.value = '';
                if (comoSoubeOutroInvalidoDiv) comoSoubeOutroInvalidoDiv.style.display = 'none';
            }
        }
        if (comoSoubeInvalidoDiv) comoSoubeInvalidoDiv.style.display = 'none';
    });
    // --- Evento de Gravar Cadastro ---
    gravarCadastroButton?.addEventListener('click', async ()=>{
        // Resetar estado de erro
        const errorDivs = [
            telefoneInvalidoDiv,
            cpfInvalidoDiv,
            cnpjInvalidoDiv,
            emailInvalidoDiv,
            termosInvalidoDiv,
            comoSoubeInvalidoDiv,
            comoSoubeOutroInvalidoDiv,
            tipoParticipanteInvalidoDiv
        ];
        errorDivs.forEach((div)=>{
            if (div) div.style.display = 'none';
        });
        if (mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = '';
            mensagemCadastroDiv.style.color = 'black';
        }
        // Coleta os dados
        const nome = nomeInput?.value.trim() || '';
        const telefoneRaw = (0, $gGcib.limparNumeros)(telefoneInput?.value);
        const cpfRaw = (0, $gGcib.limparNumeros)(cpfInput?.value);
        const empresa = empresaInput?.value.trim() || '';
        const cnpjRaw = (0, $gGcib.limparNumeros)(cnpjInput?.value);
        const email = emailInput?.value.trim() || '';
        const comoSoube = comoSoubeSelect?.value || '';
        const comoSoubeOutro = comoSoubeOutroInput?.value.trim() || '';
        const termosAceitos = termosCheckbox?.checked || false;
        //const tipoParticipante = tipoParticipanteSelect?.value || ''; // INCORRETO
        let tipoParticipante = '';
        tipoParticipanteRadios.forEach((radio)=>{
            if (radio.checked) tipoParticipante = radio.value;
        });
        let representante = null;
        representanteRadios.forEach((radio)=>{
            if (radio.checked) representante = radio.value === 'true';
        });
        // --- Validações ---
        let hasError = false;
        let errorMessages = [];
        if (!nome) errorMessages.push("Nome \xe9 obrigat\xf3rio.");
        if (!telefoneRaw) errorMessages.push("Celular \xe9 obrigat\xf3rio.");
        else if (telefoneRaw.length < 10 || telefoneRaw.length > 11) {
            if (telefoneInvalidoDiv) {
                telefoneInvalidoDiv.textContent = "Celular inv\xe1lido (10 ou 11 d\xedgitos).";
                telefoneInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!email) errorMessages.push("Email \xe9 obrigat\xf3rio.");
        else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                if (emailInvalidoDiv) {
                    emailInvalidoDiv.textContent = "Formato de email inv\xe1lido.";
                    emailInvalidoDiv.style.display = 'block';
                }
                hasError = true;
            }
        }
        if (cpfRaw && !(0, $gGcib.validarCPF)(cpfRaw)) {
            if (cpfInvalidoDiv) {
                cpfInvalidoDiv.textContent = "CPF inv\xe1lido.";
                cpfInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (cnpjRaw && !(0, $gGcib.validarCNPJ)(cnpjRaw)) {
            if (cnpjInvalidoDiv) {
                cnpjInvalidoDiv.textContent = "CNPJ inv\xe1lido.";
                cnpjInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!comoSoube) {
            if (comoSoubeInvalidoDiv) {
                comoSoubeInvalidoDiv.textContent = 'Selecione como ficou sabendo da feira.';
                comoSoubeInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        } else if (comoSoube === 'Outro' && !comoSoubeOutro) {
            if (comoSoubeOutroInvalidoDiv) {
                comoSoubeOutroInvalidoDiv.textContent = 'Por favor, especifique qual outro meio.';
                comoSoubeOutroInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!termosAceitos) {
            if (termosInvalidoDiv) termosInvalidoDiv.style.display = 'block';
            hasError = true;
        }
        if (!tipoParticipante) {
            if (tipoParticipanteInvalidoDiv) tipoParticipanteInvalidoDiv.style.display = 'block';
            hasError = true;
        }
        // Exibe erros gerais
        if (errorMessages.length > 0 && mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = errorMessages.join(' ');
            mensagemCadastroDiv.style.color = 'red';
            hasError = true;
        }
        // Interrompe se houver erro
        if (hasError) return;
        // Desabilita botão e mostra mensagem de processamento
        if (gravarCadastroButton) gravarCadastroButton.disabled = true;
        if (mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = 'Verificando dados...';
            mensagemCadastroDiv.style.color = 'black';
        }
        // --- Lógica de Submissão ---
        try {
            // 1. Verifica Duplicidade
            const checks = [];
            checks.push((0, $cpXHg.supabaseClient).from('participantes').select('id', {
                count: 'exact'
            }).eq('telefone', telefoneRaw));
            checks.push((0, $cpXHg.supabaseClient).from('participantes').select('id', {
                count: 'exact'
            }).eq('email', email));
            if (cpfRaw) checks.push((0, $cpXHg.supabaseClient).from('participantes').select('id', {
                count: 'exact'
            }).eq('cpf', cpfRaw));
            // if (cnpjRaw) { checks.push(...); }
            const results = await Promise.all(checks);
            if (results[0]?.data?.length > 0) throw new Error("Este Celular j\xe1 est\xe1 cadastrado.");
            if (results[1]?.data?.length > 0) throw new Error("Este Email j\xe1 est\xe1 cadastrado.");
            if (cpfRaw && results[2]?.data?.length > 0) throw new Error("Este CPF j\xe1 est\xe1 cadastrado.");
            // if (cnpjRaw && results[3]?.data?.length > 0) throw new Error('Este CNPJ já está cadastrado.');
            // 2. Inserção no Banco
            if (mensagemCadastroDiv) mensagemCadastroDiv.textContent = 'Gravando...';
            const { data: newParticipant, error: insertError } = await (0, $cpXHg.supabaseClient).from('participantes').insert([
                {
                    nome: nome,
                    telefone: telefoneRaw,
                    cpf: cpfRaw || null,
                    empresa: empresa || null,
                    cnpj: cnpjRaw || null,
                    email: email,
                    aceitou_termos: termosAceitos,
                    como_soube: comoSoube,
                    como_soube_outro: comoSoube === 'Outro' ? comoSoubeOutro : null,
                    tipo_participante: tipoParticipante,
                    representante: representante
                }
            ]).select().single();
            if (insertError) throw insertError;
            // 3. Sucesso
            if (cadastroForm) cadastroForm.reset();
            if (termosCheckbox) termosCheckbox.checked = false;
            if (comoSoubeOutroContainer) comoSoubeOutroContainer.style.display = 'none';
            if (comoSoubeOutroInput) comoSoubeOutroInput.required = false;
            showSuccessModal();
            if (nomeInput) nomeInput.focus();
        } catch (error) {
            // 4. Tratamento de Erro
            if (mensagemCadastroDiv) {
                mensagemCadastroDiv.textContent = `Erro: ${error.message || "N\xe3o foi poss\xedvel realizar o cadastro."}`;
                mensagemCadastroDiv.style.color = 'red';
            }
        } finally{
            // 5. Reabilita o Botão
            if (gravarCadastroButton) gravarCadastroButton.disabled = false;
        }
    }); // Fim do listener do botão gravar
    // --- Funções da Modal de Sucesso ---
    function showSuccessModal() {
        if (successModalOverlay) {
            if (mensagemCadastroDiv) mensagemCadastroDiv.textContent = '';
            successModalOverlay.classList.add('visible');
        } else // Fallback para a mensagem antiga caso a modal não exista
        if (mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = 'Cadastro realizado com sucesso!';
            mensagemCadastroDiv.style.color = 'green';
        }
    }
    function hideSuccessModal() {
        if (successModalOverlay) {
            successModalOverlay.classList.remove('visible');
            // Opcional: Focar no primeiro campo de novo após fechar a modal
            if (nomeInput) nomeInput.focus();
        }
    }
    // Listener para o botão OK da modal de sucesso
    successModalOkBtn?.addEventListener('click', hideSuccessModal);
    // Opcional: Fechar a modal clicando fora da caixa (no overlay)
    successModalOverlay?.addEventListener('click', (event)=>{
        if (event.target === successModalOverlay) hideSuccessModal();
    });
    // Opcional: Fechar a modal com a tecla Escape
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape' && successModalOverlay?.classList.contains('visible')) hideSuccessModal();
    });
    // --- Fim Funções Modal ---
    // --- Lógica da Modal de Termos (Existente) ---
    const termosModal = document.getElementById('termos-modal');
    const modalTriggers = document.querySelectorAll('.modal-trigger');
// ... (restante da lógica da modal de termos)
}); // Fim do DOMContentLoaded


//# sourceMappingURL=repo.8c9dc703.js.map
